import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TopBanner } from './components/TopBanner';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { WhatYouAchieve } from './components/WhatYouAchieve';
import { ProductOverview } from './components/ProductOverview';
import { Bonuses } from './components/Bonuses';
import { RealProof } from './components/RealProof';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  useEffect(() => {
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    f.fbq('init', '2292460911162237');
    f.fbq('track', 'PageView');
  }, []);
  const testimonials = [{
    name: 'Daniela M.',
    location: 'Rosario',
    text: 'Hice mis primeras minidonas el sábado siguiente de comprarlo. El lunes ya tenía 3 pedidos por WhatsApp. No lo puedo creer.'
  }, {
    name: 'Rocío P.',
    location: 'GBA Norte',
    role: 'Emprendedora desde casa',
    text: 'Siempre quise vender algo rico pero no sabía por dónde arrancar. El Tomo 6 me mostró exactamente cómo ponerle precio y no regalar mi trabajo.'
  }, {
    name: 'Claudia R.',
    location: 'Mendoza',
    text: 'Las recetas sin TACC fueron un golazo. Mi hija es celíaca y ahora hacemos las dos juntas. Y las vendo también.'
  }];
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <TopBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <WhatYouAchieve data-id="element-4" />
      <ProductOverview data-id="element-5" />
      <Bonuses data-id="element-6" />
      <Testimonials testimonials={testimonials} data-id="element-7" />
      <RealProof data-id="element-8" />
      <Pricing data-id="element-9" />
      <Guarantee data-id="element-10" />
      <FAQ data-id="element-11" />
      <CostOfInaction data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <Footer data-id="element-14" />
      <WhatsAppButton data-id="element-15" />
    </div>;
}